import { render, staticRenderFns } from "./TableView.vue?vue&type=template&id=b105b04c&scoped=true&"
import script from "./TableView.vue?vue&type=script&lang=js&"
export * from "./TableView.vue?vue&type=script&lang=js&"
import style0 from "./TableView.vue?vue&type=style&index=0&id=b105b04c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b105b04c",
  null
  
)

export default component.exports